<script>
  export let userAvatarUrl;
</script>

<div
  class="flex items-center justify-center w-24 h-24 overflow-hidden rounded-full"
>
  <img src={userAvatarUrl} alt="mockAvatar" class="w-48 max-w-none" />
</div>
